/* @flow */
import React from 'react';
import WorkingEnvironmentPage from './working-environment-page';

export class WorkingEnvironment extends React.Component {

  render () {
    return (
      <div className='working-environment'>
        <WorkingEnvironmentPage />
      </div>
    );
  }
}
export default WorkingEnvironment;



/** WEBPACK FOOTER **
 ** ./src/views/working-environment/working-environment.js
 **/